import FormVM from './form-vm';

let notice;
let $loginUnit, $signUpUnit, $lostPassUnit, $resendUnit, $successUnit, $acceptUnit, $redeemUnit;
let $activeUnit;

const easeTiming = 0.75;
const easeType = 'Power2.easeOut';

let $kannuLoginSignupForm = $('#kannu-index__login-signup-panel');

let initializePanels = function() {
  $loginUnit = $('#js-hp-login');
  $signUpUnit = $('#js-hp-signup');
  $lostPassUnit = $('#js-hp-lost-pass');
  $resendUnit = $('#js-hp-resend');
  $successUnit = $('#js-hp-success');
  $acceptUnit = $('#js-hp-invitation-accept');
  $redeemUnit = $('#js-hp-redeem');
  $activeUnit = $('.homepage__form-unit.active');
};

const focusFirstFormField = id => {
  const formContainer = document.getElementById(id)
  const firstField = formContainer.querySelector('input[type="text"]') ||
                       formContainer.querySelector('input[type="email"]')
  firstField.focus()
  firstField.select()
}

let initializeBtns = function() {
  $('.js-hp_create-account').on('click', function() {
    fadeinPanel($signUpUnit);
  });

  $('.js-hp_login').on('click', function() {
    fadeinPanel($loginUnit);
  });

  $('.js-hp_lost-password').on('click', function() {
    $('#login_select').hide();
    fadeinPanel($lostPassUnit);
  });

  $('.js-hp_resend').on('click', function() {
    $('#login_select').hide();
    fadeinPanel($resendUnit);
  });

  $('.js-oauth-btn').on('click', function(e) {
    const target = e.currentTarget;
    const parent = target.parentElement;
    if (parent && parent.id === 'register_select') {
      $.cookie('register.oauth', true, { expires: 1 });
    }
  });

  $('#email-login-btn').on('click', function(evt) {
    $('#login_select').hide();
    $('#email-login-form').show(0, () => focusFirstFormField('login_user'))
  });

  $('#email-register-btn').on('click', function(evt) {
    $('#register_select').hide();
    $('#email-register-form').show(0, () => focusFirstFormField('register_user'));
    $('#email-register-submit-btn').show();
  });
};

let initializePath = function() {
  let path = window.location.pathname;
  $activeUnit.removeClass('active');
  let height = 244;

  switch (path) {
  case '/register':
    $activeUnit = $('#js-hp-signup');
    height = 375;
    break;
  case '/sign_in':
    $activeUnit = $('#js-hp-login');
    break;
  case '/password/new':
    $activeUnit = $('#js-hp-lost-pass');
    break;
  case '/invitations/accept':
    $activeUnit = $acceptUnit;
    height = 275;
    break;
  case '/confirmation/new':
    $activeUnit = $('#js-hp-resend');
    break;
  case '/redeem/new':
    $activeUnit = $redeemUnit;
    // height = 200;
    break;
  }


  $activeUnit.addClass('active');

  const $notice = $('.notice.notice-success');

  if($notice.length) {
    setTimeout(() => {
      height += $notice.height() + 24;
      $kannuLoginSignupForm.css('min-height', height);
    }, 100);
  } else {
    $kannuLoginSignupForm.css('min-height', height);
  }
};

let fadeoutPanel = function( $panel ) {
  let left = $panel.css('left');

  TweenLite.to( $panel, easeTiming, {
    ease: easeType,
    css:{
      autoAlpha:0,
      left: -400
    },
    onComplete: function(){
      $panel.removeClass('active');
    }
  });
};


let fadeinPanel = function( $panel ) {
  let newHeight = $panel.outerHeight() + 60;
  fadeoutPanel($activeUnit);
  $activeUnit = $panel;
  $kannuLoginSignupForm.css({'height' : newHeight+'px'});
  $panel.addClass('active');
  $panel.css({'left':400});
  TweenLite.to( $panel, easeTiming, {
    ease: easeType,
    css:{
      autoAlpha:1,
      left: 0
    }
  });
  let $firstInput = $panel.find('input[type!=\'hidden\']')[0];
  if (typeof $firstInput !== 'undefined'){
    setTimeout(function() {
      $firstInput.focus();
    }, 200);
  }
};

let getErrorsFromResponse = function(json) {
  if (json.errors) {
    return json.errors;
  }
  if (json.error) {
    return [json.error];
  }
  return '';
};

let initAjaxEvents = function() {
  initCommonAjaxEvents();
  initRegisterAjaxEvents();
  initAcceptInviteAjaxEvents();
  initLoginAjaxEvents();
  initForgotPasswordAjaxEvents();
  initResendConfirmationAjaxEvents();
  initSSOToggleEvents();
};

let createNotice = function(container, errors) {
  let aMessages = [];
  for (let i = 0; i < errors.length; i++) {
    aMessages.push(errors[i]);
  }
  let params = {
    title: 'Error',
    message: aMessages,
    type: 'danger',
    dismissible: true
  };
  if(notice){
    notice.destroy();
  }
  notice = new Kadenze.Notice(params);
};

let initCommonAjaxEvents = function() {
  let $ele = $('form'), loader, button;

  $ele.on('ajax:before', function() {
    button = $(this).find('.ladda-button')[0];

    if(button) {
      loader = Ladda.create($(this).find('.ladda-button')[0]);
      loader.start();
    }
    $('.error-explanation', $(this)).remove();
  });

  $ele.on('ajax:success ajax:complete ajax:error', function() {
    if(loader) {
      loader.stop();
    }
  });

};

let initLoginAjaxEvents = function() {
  let $ele = $('form#login_user');

  $ele.on('ajax:error', function(event, xhr, status, error) {
    let errors = getErrorsFromResponse(xhr.responseJSON);
    createNotice('#register_errors', errors);
    $('input#user_password').val('');
    $('input#user_email').focus();
  });

  $ele.on('ajax:success', function(event, data, status) {
    Kadenze.Analytics.mpTrack('Login', {auth_type: 'email'});
    if (data.status === 'success' && data.location) {
      window.location = data.location;
    }
  });
};

let initRegisterAjaxEvents = function() {
  let $ele = $('form#register_user');
  let $recaptchaSitekey = $('#recaptcha-site-key-json').val();
  
  if ($recaptchaSitekey && Kadenze.isKadenze){
    grecaptcha.enterprise.ready(function() {
      grecaptcha.enterprise.execute($recaptchaSitekey, {action: 'external_imports'}).then(function (token) {
        document.getElementById('recaptcha-token').value = token;
      });
    });
  }
  
  $ele.on('ajax:success', function(event, data, status) {
    if (data.status === 'success' && data.location) {
      ga('send', {hitType: 'event', eventCategory: 'account', eventAction: 'CompleteRegistration'});
      Kadenze.WebApp.fbEventTrack('CompleteRegistration', {});
      window.location = data.location;
    }
  });

  $ele.on('ajax:error', function(event, xhr, status, error) {
    let errors = getErrorsFromResponse(xhr.responseJSON);
    createNotice('#register_errors', errors);
  });

};

let initAcceptInviteAjaxEvents = function() {
  let $ele = $('form#accept_invitation');
  $ele.on('ajax:success', function(event, data, status) {
    if (data.status === 'success') {
      if (data.after_accept_path) {
        window.location = data.after_accept_path;
      }
    }
  });

  $ele.on('ajax:error', function(event, xhr, status, error) {
    let errors = getErrorsFromResponse(xhr.responseJSON);
    createNotice('#register_errors', errors);
  });
};

let initForgotPasswordAjaxEvents = function() {
  let $ele = $('form#forgot_password');

  $ele.on('ajax:success', function(event, data, status) {
  });

  $ele.on('ajax:error', function(event, xhr, status, error) {
    let errors = getErrorsFromResponse(xhr.responseJSON);
    createNotice('#register_errors', errors);
  });
};

let initResendConfirmationAjaxEvents = function() {
  let $ele = $('form#resend_confirmation');

  $ele.on('ajax:success', function(event, data, status) {
  });

  $ele.on('ajax:error', function(event, xhr, status, error) {
    let errors = getErrorsFromResponse(xhr.responseJSON);
    createNotice('#register_errors', errors);
  });
};

let initSSOToggleEvents = function() {
  $('.js-mobile-app').click(function(evt) {
    let provider;

    try {
      if ($(evt.target).hasClass('js-mobile-app-facebook')) {
        provider = 'Facebook';
      } else if ($(evt.target).hasClass('js-mobile-app-google')) {
        provider = 'Google';
      } else {
        throw 'Missing valid SSO Provider class.';
      }
    } catch(err) {
      Raven.captureException(err);
    }

    if (!_.isEmpty(provider)) {
      postSSOToMobile(provider);
    }

    // Prevent the page from triggering the regular SSO button click events
    // as the postSSOToMobile logic will be deferring this to the native
    // mobile app.
    evt.preventDefault();
  });
};

let postSSOToMobile = function(ssoProvider) {
  var message = {
    Provider: ssoProvider
  };

  //TODO: Add support for chrome/Android once we have an Android app
  var isWebkit = (window.webkit && window.webkit.messageHandlers);

  try{
    if (isWebkit) {
      window.webkit.messageHandlers.signInHandler.postMessage(message);
    } else{
      throw 'Unsupported mobile browser, can\'t post SSO request to mobile.';
    }
  } catch(err) {
    Raven.captureException(err);
  }
};

class UserModule {

  constructor() {
    initAjaxEvents();
    initializePanels();
    initializeBtns();
    initializePath();

    $('form', '#kannu-index__login-signup-panel, .ajax__form-holder').on('ajax:success', function() {
      let panel = $(this).parents('.homepage__form-unit').data('messagePanel');

      if(panel) {
        fadeinPanel($(panel));
      }
    });

    if ($.cookie('register.oauth')) {
      $.removeCookie('register.oauth');
      Kadenze.WebApp.fbEventTrack('CompleteRegistration', {});
      ga('send', {hitType: 'event', eventCategory: 'account', eventAction: 'CompleteRegistration'});
    }
  }
};

export default new UserModule();
